import { useEffect, useState } from 'react';
import { useNotificationCounts } from './useNotificationCounts';

const BADGE_ENABLED_KEY = 'badge_notifications_enabled';

export const useBadgeManager = () => {
  const counts = useNotificationCounts();
  const [badgeEnabled, setBadgeEnabled] = useState(() => {
    const stored = localStorage.getItem(BADGE_ENABLED_KEY);
    return stored === null ? true : stored === 'true';
  });
  const [isSupported, setIsSupported] = useState(false);

  useEffect(() => {
    setIsSupported('setAppBadge' in navigator);
  }, []);

  const totalCount = counts.contactLeads + counts.phoneLeads + counts.smsMessages;

  useEffect(() => {
    if (!isSupported || !badgeEnabled) {
      if (isSupported) {
        navigator.clearAppBadge?.();
      }
      return;
    }

    // Update badge with total count
    if (totalCount > 0) {
      navigator.setAppBadge?.(totalCount);
      // Store count for service worker
      localStorage.setItem('badge_count', totalCount.toString());
    } else {
      navigator.clearAppBadge?.();
      localStorage.removeItem('badge_count');
    }
  }, [totalCount, isSupported, badgeEnabled]);

  const toggleBadge = (enabled: boolean) => {
    setBadgeEnabled(enabled);
    localStorage.setItem(BADGE_ENABLED_KEY, enabled.toString());
    
    if (!enabled && isSupported) {
      navigator.clearAppBadge?.();
      localStorage.removeItem('badge_count');
    }
  };

  const clearBadge = () => {
    if (isSupported) {
      navigator.clearAppBadge?.();
      localStorage.removeItem('badge_count');
    }
  };

  return {
    isSupported,
    badgeEnabled,
    totalCount,
    toggleBadge,
    clearBadge,
  };
};
